/*
 * @Descripttion:底层公共接口
 * @version: v1
 * @Author: Terry
 * @Date: 2021-12-25 17:55:20
 * @LastEditors: Terry
 * @LastEditTime: 2022-01-27 23:12:22
 */ 
var domain = process.env.VUE_APP_BASE_WSS;
const api = {
    'BI':{
        'certification': domain + '/certification',
        'greenSite':domain + '/greenSite',
        'elevator':domain + '/elevator',
        'towerCrane':domain + '/towerCrane',
    },
    'auth': {
        'getQrCode':'platform/admin/v1/auth/loginQrCode',
        'checkLogin':'platform/admin/v1/auth/checkLogin',
        'pcLogin':'platform/admin/v1/auth/pcLogin',
      },
      'project':{
        "getList":'platform/admin/v1//project/getList',
      },
}
module.exports =  api;



